import { createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "py-10" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<h1 class=\"anchor fw-bolder mb-3\" id=\"image-usage\"><a href=\"#image-usage\"></a> Image Usage </h1><div class=\"py-5\"> Use svg icons as image with <code>&lt;img&gt;</code> tag as shown below: </div><div class=\"py-5\"><div class=\"rounded border d-flex flex-wrap p-10\"><img src=\"media/icons/duotone/Design/Adjust.svg\" class=\"h-40px me-10\"><img src=\"media/icons/duotone/Code/Git3.svg\" class=\"h-40px me-10\"><img src=\"media/icons/duotone/Communication/Chat2.svg\" class=\"h-40px me-10\"><img src=\"media/icons/duotone/Design/Brush.svg\" class=\"h-40px me-10\"><img src=\"media/icons/duotone/Design/Sketch.svg\" class=\"h-40px me-10\"><img src=\"media/icons/duotone/Files/File-plus.svg\" class=\"h-40px me-10\"><img src=\"media/icons/duotone/General/Settings-2.svg\" class=\"h-40px me-10\"><img src=\"media/icons/duotone/Tools/Tools.svg\" class=\"h-40px me-10\"><img src=\"media/icons/duotone/Shopping/Chart-bar3.svg\" class=\"h-40px me-10\"></div></div>", 3)
const _hoisted_5 = { class: "py-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_5, [
      _createVNode(_component_CodeHighlighter, { lang: "html" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(`<img
          src="media/icons/duotone/Design/Adjust.svg"
          class="h-40px me-10"
        />
        <img src="media/icons/duotone/Code/Git3.svg" class="h-40px me-10" />
        <img
          src="media/icons/duotone/Communication/Chat2.svg"
          class="h-40px me-10"
        />
        <img src="media/icons/duotone/Design/Brush.svg" class="h-40px me-10" />
        <img src="media/icons/duotone/Design/Sketch.svg" class="h-40px me-10" />
        <img
          src="media/icons/duotone/Files/File-plus.svg"
          class="h-40px me-10"
        />
        <img
          src="media/icons/duotone/General/Settings-2.svg"
          class="h-40px me-10"
        />
        <img src="media/icons/duotone/Tools/Tools.svg" class="h-40px me-10" />
        <img
          src="media/icons/duotone/Shopping/Chart-bar3.svg"
          class="h-40px me-10"
        />`), 1)
        ]),
        _: 1
      })
    ])
  ]))
}